import { Pipe, PipeTransform } from '@angular/core';

import { PessoaContato } from '../pessoa-contato';
import { isContatoTipoPrimario } from '../tipo';

@Pipe({
    name: 'pessoaContatoPrimarioFilter',
    pure: false
})
export class PessoaContatoPrimarioFilterPipe implements PipeTransform {
    transform(contatos: PessoaContato[] = []): PessoaContato[] {
        if (!contatos || contatos.length === 0) {
            return contatos;
        }

        return contatos.filter(contato => isContatoTipoPrimario(contato.tipo));
    }
}
